import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import * as React from "react";
import Colors from "../../../../resources/Colors";
import CustomMenuItem from "../CustomMenuItem/CustomMenuItem";
import classes from "./CustomMenu.module.css";
export default function CustomMenu(props) {
  const [keepOpen, setKeepOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {  
    if (!props.keepOpen) {
      handleClose();
    }

    setKeepOpen(props.keepOpen);
  }, [props.keepOpen]);

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {props.isHeaderMode && (
          <ExpandMoreIcon
            sx={{ color: Colors.URTON_MAIN_COLOR }}
            className={classes.menuButton}
          />
        )}
        {(!props.isHeaderMode && !props.isSideBarMode) && (
          // <div className={classes.sideBarItem}>
          //   <img src={props.icon} className={classes.centerImg} />
          //   <div>Admin</div>
          // </div>
          
          
          <MoreVertIcon
            sx={{ color: Colors.URTON_MAIN_COLOR }}
            className={classes.menuButton}
          />
        )}
        {props.isSideBarMode && (
          <div className={classes.sideBarItem}>
            <img src={props.icon} className={classes.centerImg} />
            <div>Admin</div>
          </div>
        )}
      </Button>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "account-menu",
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {props.menuItems.map((item) => {
          return (
            <CustomMenuItem
              key={item.name}
              handleClick={item.action}
              closeMenu={handleClick}
              keepOpen={keepOpen}
              {...item}
            ></CustomMenuItem>
          );
        })}
      </Menu>
    </div>
  );
}
